import cn from 'classnames';
import { useState, useEffect } from 'react';

import globalStyles from '../../../styles/pages/index.module.scss';
import CategoriesAside from '../../components/CategoriesAside/CategoriesAside';
import CategoriesBanner from '../../components/CategoriesBanner/CategoriesBanner';
import CategoriesSelect from '../../components/CategoriesSelect/CategoriesSelect';
import CustomMetaHead from '../../components/CustomMetaHead';
import DeliveryBanner from '../../components/DeliveryBanner/DeliveryBanner';
import FavoritesAside from '../../components/FavoritesAside/FavoritesAside';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import Navigation from '../../components/Navigation/Navigation';
import SmartProductMenu from '../../components/ProductsMenu/SmartProductMenu';
import META_DATA from '../../constants/metaData';
import CartStore from '../../store/cart';
import CategoryStore from '../../store/categories';
import DeliveryMode from '../../store/deliveryMode';
import ProductsCollection from '../../store/productsCollection';
import SortBy from '../../store/productsSort';
import BANNER_SORT_OPTIONS from '../../utils/bannerOptions';
import { getOrFetchFooterLinks } from '../../utils/footerLinks';
import { getOrFetchNavigationLinks } from '../../utils/navigationLinks';
import pageStyles from '../offers/offers.module.scss';

export default function Super({ navigation, footerLinks, meta }) {
  const [showBySelection, setShowBySelection] = useState(BANNER_SORT_OPTIONS.catalog);
  const [numOfProducts, setNumOfProducts] = useState(0);
  const [deliveryMode, setDeliveryMode] = useState('');
  const [productCollections, setProductCollections] = useState();
  const [categories, setCategories] = useState();
  const [isCartVisible, setIsCartVisible] = useState(false);
  const slug = ['smart'];

  useEffect(() => {
    const subscriptionDeliveryMode = DeliveryMode.subscribe(setDeliveryMode);
    const productsCollection$ = ProductsCollection.subscribe(setProductCollections);
    const isCartVisible$ = CartStore.getIsVisble$().subscribe(setIsCartVisible);
    const sortBy$ = SortBy.subscribe(setShowBySelection);
    const categories$ = CategoryStore.subscribe(setCategories);
    return () => {
      sortBy$.unsubscribe();
      categories$.unsubscribe();
      isCartVisible$.unsubscribe();
      productsCollection$.unsubscribe();
      subscriptionDeliveryMode.unsubscribe();
    };
  }, []);

  return (
    <>
      <CustomMetaHead meta={meta} />
      <div className={globalStyles.headerContainer}>
        <Header navigation={navigation} />
      </div>

      <Navigation navigation={navigation} />
      <DeliveryBanner />

      <CategoriesSelect slug={slug} />

      <main
        className={cn(pageStyles.main, {
          [pageStyles.spaceOpenCart]: isCartVisible,
        })}
      >
        <div className={cn([pageStyles.mainLeft, pageStyles.listBanner])}>
          <div className={cn([pageStyles.sticky])}>
            <CategoriesBanner
              onChangeOrderBy={e => SortBy.update(e.target.value)}
              {...{
                showBySelection,
                numOfProducts,
                categoryName: 'Έξυπνες αγορές',
                subCategoryName: null,
                slug,
                deliveryMode,
                isProductList: false,
              }}
            />
          </div>

          <section className={pageStyles.mainContent}>
            <div className={pageStyles.hideOnSmallScreen}>
              <div className={cn([pageStyles.sticky, pageStyles.categoriesAsideTop])}>
                <FavoritesAside />
                <CategoriesAside slug={slug} />
              </div>
            </div>
            <div className={pageStyles.offerListWrapper}>
              {/* <div className={pageStyles.offerListContainer}>
                <OfferList
                  offers={[]}
                  categories={categories}
                  waveSpecialProductsGrouped={waveSpecialProductsGrouped}
                  showBySelection={showBySelection}
                />
              </div> */}
              <SmartProductMenu
                isSecondLevelPage={false}
                categories={categories}
                productCollections={productCollections}
                slug={slug}
                setNumOfProducts={setNumOfProducts}
                deliveryMode={deliveryMode}
                showBySelection={showBySelection}
              />
            </div>
          </section>
        </div>
      </main>
      <Footer footerLinks={footerLinks} />
    </>
  );
}

export async function getStaticProps() {
  const [{ data: navigation }, footerLinks] = await Promise.all([getOrFetchNavigationLinks(), getOrFetchFooterLinks()]);

  const meta = META_DATA[process.env.appName].offers;

  return {
    props: { navigation, footerLinks, meta },
  };
}
